import { resolveTemplate } from './crawl-template-resolver';

export const getSuggestedTemplates = (sectionsCrawlData, templateSections) => {
  const parsed = typeof sectionsCrawlData === 'string' ? JSON.parse(sectionsCrawlData) : sectionsCrawlData;
  return parsed
    .map(section => {
      // if(section)
      return resolveTemplate(section, templateSections);
    })
    .filter(Boolean)
    .map(template => {
      return {
        ...template,
        selected: true,
      };
    });
};

export function deriveContentTags(section) {
  const tags = new Set();

  // Gom toàn bộ blocks tùy theo type_signal (mỗi loại có vị trí blocks khác nhau)
  let allBlocks = [];
  if (section.type_signal === 'side_by_side') {
    section.columns?.forEach(col => allBlocks.push(...col.blocks));
    tags.add(`columns_${section.layout?.column_count || 2}`);
    if (section.layout?.media_column && section.layout.media_column !== 'none') {
      tags.add(`media_${section.layout.media_column}`);
    }
  } else if (section.type_signal === 'hero_banner') {
    allBlocks = section.blocks || [];
    if (section.layout?.background_media?.media_type) {
      tags.add(`bg_${section.layout.background_media.media_type}`); // bg_image / bg_video / bg_gif
    }
    tags.add(`overlay_${section.layout?.overlay_darkness || 'none'}`);
  } else if (section.type_signal === 'carousel') {
    section.content?.cards?.forEach(card => allBlocks.push(...card.blocks));
    tags.add(`cards_${section.layout?.card_count || 0}`);
    if (section.content?.section_rating) tags.add('has_section_rating');
    if (section.content?.heading) tags.add('heading_content');
    if (section.content?.subheading) tags.add('subheading_content');
  } else if (section.type_signal === 'feature_grid_media') {
    tags.add(`grid_${section.layout?.grid_columns || 0}x${section.layout?.grid_rows || 0}`);
    tags.add(`card_style_${section.layout?.card_style || 'unknown'}`);
    if (section.content?.primary_media) {
      tags.add('has_primary_media');
    } else {
      tags.add('has_no_primary_media');
    }
  } else if (section.type_signal === 'media_center_grid') {
    tags.add(`items_per_side_${section.layout?.items_per_side || 0}`);
  } else if (section.type_signal === 'faq_accordion') {
    tags.add(`faq_${section.layout?.faq_style || 'plain'}`);
    tags.add(`icon_${section.layout?.expand_icon || 'none'}`);
    tags.add(`faq_count_${section.content?.faq_items?.length || 0}`);
  } else if (section.type_signal === 'marquee') {
    tags.add(`marquee_${section.layout?.marquee_item_style || 'unknown'}`);
  }

  // Tag theo block_type xuất hiện (dùng chung cho mọi loại có blocks)
  const blockTypeCounts = {};
  allBlocks.forEach(b => {
    tags.add(b.block_type); // cta, spec_table, tabs, accordion, testimonial...
    blockTypeCounts[b.block_type] = (blockTypeCounts[b.block_type] || 0) + 1;

    // Tinh chỉnh riêng cho media: phân biệt video/gif/image thay vì chỉ 'media'
    if (b.block_type === 'media' && b.media?.media_type) {
      tags.add(`media_${b.media.media_type}`); // media_video, media_gif, media_image
    }
    if (b.block_type === 'cta' && b.cta_items?.length > 1) {
      tags.add('multi_cta');
    }
    if (b.block_type === 'testimonial' && b.testimonial_data?.verified) {
      tags.add('verified_testimonial');
    }
  });

  // Tag mật độ nội dung — hữu ích để phân biệt bản "đơn giản" vs "đầy đủ" cùng type_signal
  tags.add(`block_count_${allBlocks.length}`);

  return Array.from(tags);
}

export function normalizeImgSrc(src) {
  if (!src || typeof src !== 'string') {
    return '';
  }

  let trimmedSrc = src.trim().replace('{width}', '1024');

  if (trimmedSrc.startsWith('//')) {
    return `https:${trimmedSrc}`;
  }

  return trimmedSrc;
}
